import { ReactElement, useEffect, useRef } from 'react';
import { UseFormRegisterReturn } from 'react-hook-form';

type Props = {
  register: UseFormRegisterReturn;
  disabled?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  className?: string;
  value: any;
  rows: number;
};

const TextArea = ({ register, disabled, onChange, className, value, rows = 1 }: Props) => {
  const localTextareaRef = useRef<HTMLTextAreaElement | null>(null);

  const adjustHeight = (textarea: HTMLTextAreaElement) => {
    textarea.style.height = 'auto';
    textarea.style.height = `${textarea.scrollHeight}px`;
  };

  const setCombinedRef = (el: HTMLTextAreaElement | null) => {
    register.ref(el);
    localTextareaRef.current = el;
  };

  if (localTextareaRef.current) {
    adjustHeight(localTextareaRef.current);
  }

  return (
    <textarea
      {...register}
      rows={rows}
      disabled={disabled}
      onChange={e => {
        onChange?.(e);
        adjustHeight(e.target);
      }}
      className={className || ''}
      ref={setCombinedRef}
      value={value}
    />
  );
};

export default TextArea;
